import { apiRequest } from "../core";

export function getNewsFeed(skip, take) {
  let url = new URL(process.env.REACT_APP_BACKEND_HOST + "/api/news");

  let params = {};
  if (skip) {
    params.skip = skip;
  }
  if (take) {
    params.take = take;
  }

  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return apiRequest(url);
}

export function getNewsByAlias(alias) {
  let url = new URL(process.env.REACT_APP_BACKEND_HOST + `/api/news/${alias}`);
  return apiRequest(url);
}